
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "leaflet/dist/leaflet.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "font-awesome/css/font-awesome.min.css";
import "slick-carousel/slick/slick-theme.css";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from './components/Header';
import HeroSection from './components/HeroSlider';
import Footer from './components/Footer';
import AboutStyleThree from './pages/AboutStyleThree';
import AboutStyleTwo from './components/AboutSection';
import TermsConditions from './components/TermsConditions';
import PrivacyPolicy from './components/PrivacyPolicy';
import Booking from './pages/Booking';
import Gallery from './pages/Gallery';
import CareerSection from './pages/CareerSection';
import Enquiry from './pages/Enquiry';
import ContactUs from './pages/ContactUs';
import Packages from './pages/Packages';
import OurNetwork from './pages/OurNetwork';
import OurFleets from './pages/OurFleets';
import Mumbaitogoacab from './pages/Mumbai to Goa Cab';
import Mumbaitogoacabbooking from './pages/Mumbai to Goa Cab Booking';
import ScrollToTop from './components/ScrollToTop';
import Navimumbaitogoacabservice from './pages/Navi Mumbai to Goa Cab Service';
import Mumbaiairporttogoacab from './pages/Mumbai Airport to Goa Cab';
import Mumbaitogoacabservice from './pages/Mumbai to Goa Cab Service';
import Bestmumbaitogoacabservice from './pages/Best Mumbai to Goa Cab Service';
import Thanetogoacabs from './pages/Thane to Goa Cabs';
import Mumbaitogoainnovacrystacab from './pages/Mumbai to Goa Innova Crysta Cab';
import Mumbaitogoaonewaycab from './pages/Mumbai to Goa One Way Cab';
import Goacabsservice from './pages/Goa Cabs Service';
import Goatomumbaicab from './pages/Goa to Mumbai Cab';
import Goatonavimumbaicab from './pages/Goa to Navi Mumbai Cab';
import Goatomumbaiairportcab from './pages/Goa to Mumbai Airport Cab';
import Goatomumbaionewaycab from './pages/Goa to Mumbai One Way Cab';
import Mumbaitolonavalacab from './pages/Mumbai to Lonavala Cab';
import Lonavalatomumbaicab from './pages/Lonavala to Mumbai Cab';
import Bestlonavalatonavimumbaicab from './pages/Best Lonavala to Navi Mumbai Cab';
import Navimumbaiairportcab from './pages/Navi Mumbai Airport Cab';
import Navimumbaicabservice from './pages/Navi Mumbai Cab Service';
import Kharghartaxiservice from './pages/Kharghar Taxi Services';
import Mumbaiairportcabs from './pages/Mumbai Airport Cabs';
import Mumbaicabservice from './pages/Mumbai Cab Service';
import Mumbaionlinecabservice from './pages/Mumbai Online Cab Service';
import Mumbaitomahabaleshwar from './pages/Mumbai to Mahabaleshwar Cab';
import Mumbaioutstationcab from './pages/Mumbai Outstation Cabs';
import Innovacrystaonrentinmumbai from './pages/Innova Crysta On Rent in Mumbai';
import Ertigaonrentinmumbai from './pages/Ertiga On Rent in Mumbai';
import Mumbaitopunecabs from './pages/Mumbai to Pune Cabs';
import Mumbaiairporttopunecab from './pages/Mumbai Airport to Pune Cab';
import Cabserviceinthane from './pages/Cab Service in Thane';
import Cabserviceinpanvel from './pages/Cab Service in Panvel';
import Sedancabservicemumbai from './pages/Sedan Cab Service Mumbai';
import Mumbaidarshancabbooking from './pages/Mumbai Darshan Cab Booking';
import Bookmumbaitooutstationcab from './pages/Book Mumbai to Outstation Cab Service';
import Mumbaitoallmaharastracab from './pages/Mumbai to All Maharashtra Cab';
import Mumbaitopanindiacab from './pages/Mumbai to Pan India Cab Service';
import Service from './pages/Service';
import ContactButtons from './components/ContactButtons';

function App() {
  return (
    <Router>
<Header/>
      <ContactButtons />
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HeroSection />} />
        <Route path="/about-us" element={<AboutStyleTwo />} />
        <Route path="/term-condition" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/packages" element={<Packages />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/career" element={<CareerSection />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/our-network" element={<OurNetwork />} />
        <Route path="/our-fleet" element={<OurFleets />} />
        <Route path="/services" element={<Service />} />



<Route path="/Mumbai-to-Goa-Cab" element={<Mumbaitogoacab />} />
<Route path="/Mumbai-to-Goa-Cab-Booking" element={<Mumbaitogoacabbooking />} />
<Route path="/Navi-Mumbai-to-Goa-Cab-Service" element={<Navimumbaitogoacabservice />} />
<Route path="/Mumbai-Airport-to-Goa-Cab" element={<Mumbaiairporttogoacab />} />
<Route path="/Mumbai-to-Goa-Cab-Service" element={<Mumbaitogoacabservice />} />
<Route path="/Best-Mumbai-to-Goa-Cab-Service" element={<Bestmumbaitogoacabservice />} />
<Route path="/Thane-to-Goa-Cabs" element={<Thanetogoacabs />} />
<Route path="/Mumbai-to-Goa-Innova-Crysta-Cab" element={<Mumbaitogoainnovacrystacab />} />
<Route path="/Mumbai-to-Goa-One-Way-Cab" element={<Mumbaitogoaonewaycab />} />
<Route path="/Goa-Cabs-Service" element={<Goacabsservice />} />
<Route path="/Goa-to-Mumbai-Cab" element={<Goatomumbaicab />} />
<Route path="/Goa-to-Navi-Mumbai-Cab" element={<Goatonavimumbaicab />} />
<Route path="/Goa-to-Mumbai-Airport-Cab" element={<Goatomumbaiairportcab />} />
<Route path="/Goa-to-Mumbai-One-Way-Cab" element={<Goatomumbaionewaycab />} />
<Route path="/Mumbai-to-Lonavala-Cab" element={<Mumbaitolonavalacab />} />
<Route path="/Lonavala-to-Mumbai-Cab" element={<Lonavalatomumbaicab />} />
<Route path="/Best-Lonavala-to-Navi-Mumbai-Cab" element={<Bestlonavalatonavimumbaicab />} />
<Route path="/Navi-Mumbai-Airport-Cab" element={<Navimumbaiairportcab />} />
<Route path="/Navi-Mumbai-Cab-Service" element={<Navimumbaicabservice />} />
<Route path="/Kharghar-Taxi-Services" element={<Kharghartaxiservice />} />
<Route path="/Mumbai-Airport-Cabs" element={<Mumbaiairportcabs />} />
<Route path="/Mumbai-Cab-Service" element={<Mumbaicabservice />} />
<Route path="/Mumbai-Online-Cab-Service" element={<Mumbaionlinecabservice />} />
<Route path="/Mumbai-to-Mahabaleshwar-Cab" element={<Mumbaitomahabaleshwar />} />
<Route path="/Mumbai-Outstation-Cabs" element={<Mumbaioutstationcab />} />
<Route path="/Innova-Crysta-On-Rent-in-Mumbai" element={<Innovacrystaonrentinmumbai />} />
<Route path="/Ertiga-On-Rent-in-Mumbai" element={<Ertigaonrentinmumbai />} />
<Route path="/Mumbai-to-Pune-Cabs" element={<Mumbaitopunecabs />} />
<Route path="/Mumbai-Airport-to-Pune-Cab" element={<Mumbaiairporttopunecab />} />
<Route path="/Cab-Service-in-Thane" element={<Cabserviceinthane />} />
<Route path="/Cab-Service-in-Panvel" element={<Cabserviceinpanvel />} />
<Route path="/Sedan-Cab-Service-Mumbai" element={<Sedancabservicemumbai />} />
<Route path="/Mumbai-Darshan-Cab-Booking" element={<Mumbaidarshancabbooking />} />
<Route path="/Book-Mumbai-to-Outstation-Cab-Service" element={<Bookmumbaitooutstationcab />} />
<Route path="/Mumbai-to-All-Maharashtra-Cab" element={<Mumbaitoallmaharastracab />} />
<Route path="/Mumbai-to-Pan-India-Cab-Service" element={<Mumbaitopanindiacab />} />

     </Routes>


<Footer/>
    </Router>
  );
}

export default App;
